import { read, write } from "@/lib/storage";
import { getBook } from "@/lib/catalog";

export function addToCart(bookId, qty = 1) {
  const book = getBook(bookId);
  if (!book || book.stock <= 0) throw new Error("Stok buku ini sedang habis (demo).");
  const cart = read("cart");
  const ex = cart.find((c) => c.bookId === bookId);
  const next = Math.min(book.stock, (ex?.qty || 0) + qty);
  write("cart", ex ? cart.map((c) => (c.bookId === bookId ? { ...c, qty: next } : c)) : [...cart, { bookId, qty: next }]);
}

export function setQty(bookId, qty) {
  const book = getBook(bookId);
  const q = Math.max(1, Math.min(book?.stock || 1, qty));
  write("cart", read("cart").map((c) => (c.bookId === bookId ? { ...c, qty: q } : c)));
}

export const removeFromCart = (bookId) => write("cart", read("cart").filter((c) => c.bookId !== bookId));

export const SHIPPING = [
  { id: "ambil", label: "Ambil di toko fisik (demo)", fee: 0 },
  { id: "reguler", label: "Pengiriman reguler (demo)", fee: 15000 },
];

export const PLAN = {
  id: "tahunan",
  name: "Logika Filsuf Tahunan",
  price: 299000,
  benefits: [
    "Rekomendasi buku bacaan",
    "Bedah Argumen mendalam dengan riwayat lengkap",
    "Ekspor catatan & analisis (rencana fitur)",
    "Diskon 10% pembelian di Toko Buku (demonstrasi)",
    "Akses awal ke fitur baru",
  ],
};
